import cx from 'classnames'
import type { ComponentProps } from 'react'
// oxlint-disable-next-line no-restricted-imports
import { NavLink as NavLinkRouter } from 'react-router'

import {
  type PropsWithSafeExtra,
  safeRestProps,
} from '../../libs/safeRestProps'
import type { Button } from '../button/Button'
import { buttonStyles } from '../button/buttonStyles'

type Props = PropsWithSafeExtra<
  typeof NavLinkRouter,
  'to' | 'className' | 'children' | 'onClick',
  {
    /**
     * The variant style to use for the link
     * @defaultValue `'text'`
     */
    buttonVariant?: Extract<
      ComponentProps<typeof Button>['variant'],
      'text' | 'discreet'
    >
    disabled?: boolean
  }
>

export const NavLink = ({
  className,
  buttonVariant = 'text',
  disabled = false,
  extraProps = {},
  ...restProps // Needed since some components might pass other props like aria-*, data-* etc. or spread {...props} that isn't type checked
}: Props) => (
  <NavLinkRouter
    {...safeRestProps(extraProps, restProps)}
    className={cx(
      buttonStyles({
        isDanger: false,
        isFullWidth: false,
        variant: buttonVariant,
        disabled,
      }),
      className,
    )}
  />
)
